import config from '../config';
import { createBrowserHistory } from 'history';

const locationFeatures = {
  ...createAppHistory(),
};

function createAppHistory() {
  if (config.history.enabled) {
    const history = createBrowserHistory();

    return {
      invoke: {
        get: (): string => window.location.href,
        set: ([path]: [string]) => {
          history.push(path);
        },
        replace: ([path, removeHash]: [string, boolean]) => {
          const newLocation = {
            pathname: path,
            ...(removeHash ? { hash: '' } : null),
          };
          history.replace(newLocation);
        },
        replaceToExternalPage: ([url]: [string]) => {
          window.location.replace(url);
        },
      },
      on: {
        onUrlChange(callback: Function) {
          const unsubscribe = history.listen(({ location }) => {
            callback(location);
          });

          return () => {
            unsubscribe();
          };
        },
      },
    };
  }

  return {
    invoke: {
      get: (): string => window.location.href,
      set: () => {},
      replace: () => {},
      replaceToExternalPage: () => {},
    },
    on: {
      onUrlChange() {
        return () => {};
      },
    },
  };
}

export default locationFeatures;
